import { useReducer } from "react";
import { useContext } from "react";
import { createContext } from "react";
import { CONTACT_REQUEST_DELETE, CONTACT_REQUEST_GET_ALL } from "../common/constants";
import { ContactRequestReducer } from "../Reducers/ContactRequestReducer";
import { LoadingContext } from "./LoadingContext";

export const ContactRequestContext = createContext();

const ContactRequestContextProvider = (props) => {
	const [contactRequest, setContactRequestDispatch] = useReducer(ContactRequestReducer);
	const { loadingData, setLoadingData } = useContext(LoadingContext);

	const getAllContactRequest = (successCb = () => {}, failedCb = () => {}) => {
		setLoadingData({
			is_loading: true,
			message: "Loading All Contact Request....",
		});

		setContactRequestDispatch({
			type: CONTACT_REQUEST_GET_ALL,
			loading: true,
			dispatch: setContactRequestDispatch,
			successCb,
			failedCb,
			loadingCb: () =>
				setLoadingData({
					is_loading: false,
					message: "",
				}),
		});
	};

	const deleteContactRequest = (id, successCb = () => {}, failedCb = () => {}) => {
		setLoadingData({
			is_loading: true,
			message: "Deleting Contact Request....",
		});

		setContactRequestDispatch({
			type: CONTACT_REQUEST_DELETE,
			loading: true,
			id,
			dispatch: setContactRequestDispatch,
			successCb,
			failedCb,
			loadingCb: () =>
				setLoadingData({
					is_loading: false,
					message: "",
				}),
		});
	};

	return (
		<ContactRequestContext.Provider
			value={{ contactRequest, getAllContactRequest, deleteContactRequest }}
		>
			{props.children}
		</ContactRequestContext.Provider>
	);
};

export default ContactRequestContextProvider;
